<template>
    <!-- 팝업 -->

    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk" style="display: block; max-width: 1200px">
        <button class="close_btn icon_wrap" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="pop_tit">
            <p>{{ state.data.title }}</p>
        </div>
        <div class="date_wrap">
            <span class="state_tage" :class="[state.data.state === 3 ? 'finish' : '']">{{ state.data.state === 3 ? "종료" : "대기중" }}</span>
            <div class="collection_period" v-if="state.data.recruitStartDate && state.data.recruitEndDate">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    모집기간
                </span>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.recruitStartDate), ".", false) }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.recruitEndDate), ".", false) }}</span>
            </div>
            <div class="end_point" v-if="state.data.applyDate !== null">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    신청종료일
                </span>
                <span>{{ state.data.applyDate !== null ? CommonUtils.dateFormat(new Date(state.data.applyDate), ".", false) : "" }}</span>
            </div>
            <div class="activity_duration" v-if="state.data.activeStartDate && state.data.activeEndDate">
                <span>
                    <img src="img/cal_icon_blue.png" alt="" />
                    활동기간
                </span>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.activeStartDate), ".", false) }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.activeEndDate), ".", false) }}</span>
            </div>
        </div>
        <div class="list_container">
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <span>{{ state.cntApply }} 명</span>
                </div>
                <button type="button" class="excel_btn icon_wrap" @click="downloadFile(false)"><img src="img/excel_icon.png" alt="" /></button>

                <div class="list_th">
                    <span class="_num">번호</span>
                    <span class="_name">이름</span>
                    <span class="_gender">성별</span>
                    <span class="_ph">전화번호</span>
                    <span class="_date">신청일</span>
                    <span class="">신청서</span>
                </div>
                <div class="list_wrap custom_scroll light_gray">
                    <div class="list_td" v-for="(item, idx) in state.applyList" :key="item.idx">
                        <span class="_num">{{ (state.applyPage - 1) * state.size + (idx + 1) }}</span>
                        <span class="_name">{{ item.memberVO.memberVO.name }}</span>
                        <span class="_gender">{{ item.memberVO.gender === "M" ? "남자" : item.memberVO.gender === "F" ? "여자" : "기타" }}</span>
                        <span class="_ph">{{ CommonUtils.convertPhoneNumReal(item.memberVO.phone) }}</span>
                        <span class="_date">{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</span>
                        <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                    </div>
                </div>
                <PageBtn :currentPage="state.applyPage" :perPage="state.size" :totalLength="state.cntApply" @onPaging="applyPaging"></PageBtn>
            </div>
            <div class="right">
                <div class="num_wrap">
                    <span>선발인원</span>
                    <span>{{ state.cntPick }} 명</span>
                </div>
                <button type="button" class="excel_btn icon_wrap" @click="downloadFile(true)"><img src="img/excel_icon.png" alt="" /></button>
                <div class="list_th">
                    <span class="_num">번호</span>
                    <span class="_name">이름</span>
                    <span class="_gender">성별</span>
                    <span class="_ph">전화번호</span>
                    <span class="_date">신청일</span>
                    <span class="">신청서</span>
                </div>
                <div class="list_wrap custom_scroll light_gray">
                    <div class="list_td" v-for="(item, idx) in state.pickList" :key="item.idx">
                        <span class="_num">{{ (state.pickPage - 1) * state.size + (idx + 1) }}</span>
                        <span class="_name">{{ item.memberVO.memberVO.name }}</span>
                        <span class="_gender">{{ item.memberVO.gender === "M" ? "남자" : item.memberVO.gender === "F" ? "여자" : "기타" }}</span>
                        <span class="_ph">{{ item.memberVO.phone }}</span>
                        <span class="_date">{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</span>
                        <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                    </div>
                </div>
                <PageBtn :currentPage="state.pickPage" :perPage="state.size" :totalLength="state.cntPick" @onPaging="pickPaging"></PageBtn>
            </div>
        </div>
        <div class="memo_wrap">
            <textarea name="" id="" placeholder="메모" class="custom_scroll light_gray" v-model="state.data.memo"></textarea>
        </div>
        <div class="btn_wrap _default _center">
            <button class="submit_btn w_120" @click="save">확인</button>
        </div>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>

    <AnswerModal
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getApplyList();
            getPickList();
        "
    ></AnswerModal>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        AnswerModal,
        ModalDefault,
    } from "@/BaseComponent";
    import PageBtn from "../pageBtn.vue";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            data: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "save"],
        components: { AnswerModal, ModalDefault, PageBtn },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,
                applyList: [] as Array<any>,
                applyPage: 1 as number,
                pickList: [] as Array<any>,
                pickPage: 1 as number,
                cntApply: 0 as number,
                cntPick: 0 as number,
                size: 20 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,
            });

            onMounted(() => {
                state.idx = props.idx;
                state.data = props.data;

                document.body.style.overflow = "hidden";

                getApplyList();
                getPickList();
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => {
                emit("close");
            };

            const getApplyList = async () => {
                const param: types.ReqBoardApplyList = {
                    page: state.applyPage,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };

                const res = await apiService.boardActivity.applyList(state.idx, param);

                if (res && res.returnCode === 0) {
                    state.applyList = res.list.data;
                    state.cntApply = res.list.recordsTotal;
                }
            };

            const getPickList = async () => {
                const param: types.ReqBoardApplyList = {
                    page: state.pickPage,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };

                const res = await apiService.boardActivity.applyListPick(state.idx, param);
                if (res && res.returnCode === 0) {
                    state.pickList = res.list.data;
                    state.cntPick = res.list.recordsTotal;
                }
            };

            const save = () => {
                emit("save", state.data.memo);
            };

            const downloadFile = async (isPick: boolean) => {
                try {
                    const param: types.ReqBoardApplyForExcel = { state: !isPick ? 1 : 2 };

                    const res = await apiService.boardActivity.exportExcel(state.idx, param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.memberVO.memberVO.name;
                state.isShowAnswer = true;
            };

            const applyPaging = (page: number) => {
                state.applyPage = page;
                getApplyList();
            };
            const pickPaging = (page: number) => {
                state.pickPage = page;
                getPickList();
            };

            return { state, closeModal, props, CommonUtils, save, downloadFile, getApplyList, getPickList, showAnswer, applyPaging, pickPaging };
        },
    };
</script>

<style scoped>
    .table_btn {
        color: #fff;
        font-weight: 500;
        background-color: var(--main_color);
        border-radius: 5px;
        font-size: 13px;
        padding: 0 5px;
    }
</style>
